// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3BQnk","alertIcon":"ConfirmModal_alertIcon__1DcH7"};